import moment from 'moment';
import URI from 'urijs';

function Request() {
};

String.prototype.trunc =
     function( n, useWordBoundary ){
         if (this.length <= n) { return this; }
         var subString = this.substr(0, n-1);
         return (useWordBoundary 
            ? subString.substr(0, subString.lastIndexOf(' ')) 
            : subString) + "...";
      };

Request.buildRequest = function(request) {
  var url = request.endpoint + "?";
  $('.js-dynamic-filter').each(function(index, element) {
    if (!$(element).data("filterDisplayable")) { return }
    var paramValue = []
    var labelValues = []
    if($(element).data('filter-type') == 'checkbox') {
      $(element).find(".js-filter-option").each(function(index, option) {
        if ($(option).is(':checked')) {
          labelValues.push($(option).siblings('.state').find('label').text());
          paramValue.push($(option).data("option-value"));
        }
      })
      if (paramValue.length > 0) {
        url += "&" + $(element).data("filter-param-key") + "=" + paramValue.join(",");
        $(element).find('.js-filter-control-description').text(labelValues.join(", ").trunc(20))
      } else {
        $(element).find('.js-filter-control-description').text('All')
      }
    } else if($(element).data('filter-type') == 'keyword') {
      let keyword = $(element).find(".js-filter-option").val();
      url += "&" + $(element).data("filter-param-key") + "=" + keyword;
      if (keyword == "") {
        $(element).find('.js-filter-control-description').text('Search');
      } else {
        $(element).find('.js-filter-control-description').text(keyword);
      }
    } else if($(element).data('filter-type') == 'community_radius') {
      let community_id = $('.js-filter-community-id-option').val();
      let radius = $('#js-filter-radius-option').val();
      if (community_id) {
        url += "&" + "community_name" + "=" + $('.js-filter-community-id-option').select2('data')[0].name
        url += "&" + "community_id" + "=" + community_id;
        url += "&" + "search_radius" + "=" + radius;
        $(element).find('.js-filter-control-description').text("<" + radius + "km : " + $('#select2-community_id-container').text().substring(1))
      } else {
        $(element).find('.js-filter-control-description').text("Select")
      }
    } else if ($(element).data('filter-type') == 'date_range') {
      var startDate = $(element).find(".js-datepicker-start-date").val()
      var endDate = $(element).find(".js-datepicker-end-date").val()
      url += "&" + $(element).find(".js-datepicker-start-date").data('filterStartDateParamKey') + "=" + startDate;
      url += "&" + $(element).find(".js-datepicker-end-date").data('filterEndDateParamKey') + "=" + endDate;
      $(element).find('.js-filter-control-description').text(moment(startDate).format("D MMM YYYY") + " - " + moment(endDate).format("D MMM YYYY"))
    }
  })
  
  if (document.getElementById('js-record-type') && document.getElementById('js-display-type')) {
    url += "&" + "record_type" + "=" + document.getElementById('js-record-type').dataset.recordType;
    url += "&" + "display_type" + "=" + document.getElementById('js-display-type').dataset.displayType;
  }

  if (request.endpoint === "/metrics/incidents.json") {
    if (request.group) { // For Metrics
      url += "&" + "group" + "=" + request.group;
    }
    
    if (request.start_date && request.end_date) { // For Metrics
      url += "&" + "start_date" + "=" + request.start_date + "&" + "end_date" + "=" + request.end_date 
    } 

    if (request.attack_characteristics ) { // For Metrics
      url += "&" + "attack_characteristics" + "=" + true
    } 

    if (request.private_actors) { // For Metrics
      url += "&" + "private_actors" + "=" + request.private_actors
    }

    if (request.duration) { // For Metrics
      url += "&" + "duration" + "=" + request.duration
    }    
  }


  if (request.request_type) {
    url += "&" + "request_type" + "=" + request.request_type
  }

  if (request.page) {
    url += "&" + "page" + "=" + request.page
  }

  if ($('#js-explosives-filter').is(':checked')) {
    url += "&explosives=true";
  }

  url += "&" + "stream_type" + "=" + "violence";

  if (request.endpoint !== "/metrics/incidents.json") {
    $('#js-new-deep-link').attr("href", "/deep_links/new?" + new URI(url).query())
  }
  return url;
};

export default Request;


